// export const regEmail = /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/;

export const regEmail = /\S+@\S+/;

export const regZip = /^[0-9]{5}$/;

export const regZipCanada = /^[0-9a-zA-Z]{6}$/;

export const regPhone = /^(\(\d{3}\)|\d{3})\s?-?\d{3}-?\s?\d{4}$/;

export const regDot = /^[0-9]{5,7}$/;

export const regMc = /^[0-9]{6}$/;

export const regPassWord = /^\S{4,}$/;

export const regInputNumber = /(^[1-9]{1}[0-9]*$)|(^[0-9]*\.[0-9]+$)/;



// WEBPACK FOOTER //
// ./src/misc/reg.js